import { AxiosPromise } from 'axios';
import { BaseService } from '../../../../../core/services/BaseServices';

export class MessagingService extends BaseService {
  constructor() {
    super('message');
  }
  public getAllMessages(
    sourceType: string,
    sourceId: number | string,
    id: number | string,
    params: any
  ): AxiosPromise<any[]> {
    return this.httpAxios
      .get(`/${sourceType}/${sourceId}/${id}`, { params })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }

  public createNewOrEditMessage(message: any): AxiosPromise<any[]> {
    return this.httpAxios
      .post(``, message)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }

  public getUnreadCount(): AxiosPromise<any[]> {
    return this.httpAxios
      .post(`/unreadcount`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }

  public setReadMessage(messageId: any): AxiosPromise<any[]> {
    return this.httpAxios
      .post(`/readmessage/${messageId}`)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }
}

const messagingService = new MessagingService();
export default messagingService;
